import { render } from "./AiFeedbackThumbs.vue?vue&type=template&id=896d8e76&scoped=true"
import script from "./AiFeedbackThumbs.vue?vue&type=script&lang=js"
export * from "./AiFeedbackThumbs.vue?vue&type=script&lang=js"

import "./AiFeedbackThumbs.vue?vue&type=style&index=0&id=896d8e76&scoped=true&lang=css"
import "./AiFeedbackThumbs.vue?vue&type=style&index=1&id=896d8e76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896d8e76"]])

export default __exports__